import { render, staticRenderFns } from "./RealityModal.vue?vue&type=template&id=5143136e&scoped=true"
import script from "./RealityModal.vue?vue&type=script&lang=js"
export * from "./RealityModal.vue?vue&type=script&lang=js"
import style0 from "./RealityModal.vue?vue&type=style&index=0&id=5143136e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5143136e",
  null
  
)

export default component.exports